import Title from '@/components/Title';
import ExpandableSearch from '@/components/ExpandableSearch';
import Button from '@/components/Button';
import AddIcon from '@/icons/AddIcon';
import { useToggle } from '@/hooks/useToggle';
import NewCompanyInvestorDialog from '@/dialogs/NewCompanyInvestorDialog';
import { classes } from './utils';

export type HeaderProps = {
  investorId: number;
  search: string;
  onSearch: (search: string) => void;
};

export default function Header({ investorId, search, onSearch }: HeaderProps) {
  const [isNewCompanyDialogOpen, toggleNewCompanyDialog] = useToggle(false);

  return (
    <>
      {isNewCompanyDialogOpen && (
        <NewCompanyInvestorDialog
          investorId={investorId}
          onClose={() => toggleNewCompanyDialog(false)}
        />
      )}
      <div className={classes.wrapper}>
        <div className={classes.titleWrapper}>
          <Title>Companies</Title>
          <p className={classes.subtitle}>
            Select a company to edit settings & investments
          </p>
        </div>
        <div className={classes.buttonsWrapper}>
          <ExpandableSearch
            className={classes.searchButton}
            value={search}
            onChange={(update) => onSearch(update)}
            onClose={() => onSearch('')}
          />
          <Button
            className={classes.addButton}
            onClick={() => toggleNewCompanyDialog(true)}>
            <AddIcon />
            <span className={classes.buttonText}>New</span>
          </Button>
        </div>
      </div>
    </>
  );
}
